<template>
<div >

    <Navbar></Navbar>
    <div class="main-content">
		<div class="container">

            <div class="import-box" style="max-width: 560px;">
                <h2 class="mt-4 text-center">Solicitar pre entrega</h2>
                <p>
                    
                </p>
            </div>

            <div class="container">
                <div class="row">
                    
                    <div class="col-6">

                        <div class="form-group">
                            <label>Buscar vehículos</label>
                            <div class="input-group">
                                <input type="text" 
                                    class="form-control" 
                                    placeholder="Chasis, motor, marca, modelo" 
                                    v-model="searchTerms"
                                    >
                                <div class="input-group-append">
                                    <button @click="searchCars()" class="btn btn-outline-secondary" type="button">Buscar</button>
                                </div>
                            </div>
                        </div>

                        <div class="label mt-4">
                            Vehículos prontos para pre entregar
                        </div>

                        <div class="alert alert-warning" v-if="!loading && cars.length==0">
                            No se han encontrado vehículos habilitados para pre entregar
                        </div>

                        <table class="table mt-2 mb-4" v-if="cars.length>0">
                            <tr class="table-head">
                                <td>Chasis</td>
                                <td>Vehículo</td>
                                <td>Cliente</td>
                            </tr>
                            <tr v-for="item of cars" :key="item.id"  @click="selectCar(item)">
                                <td>{{item.chassis_number}}</td>
                                <td>
                                    <div class="tc">
                                        <span class="text-primary">{{item.brand.title}}</span>
                                        <span >{{item.model}}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="tc">
                                        <span class="text-primary">{{item.client.name}}</span>
                                        <span >{{item.client.business_name}}</span>
                                    </div>
                                </td>
                            </tr>
                        </table>

                    </div>
                    
                    <div class="col-6">
                        
                        <b-form-group label="Prioridad" >
                            <b-form-select v-model="form.priority" class="mb-3">
                                <b-form-select-option :value="null">Normal</b-form-select-option>
                                <b-form-select-option value="MEDIUM">Media</b-form-select-option>
                                <b-form-select-option value="HIGH" >Alta</b-form-select-option>
                            </b-form-select>
                        </b-form-group>

                        <div class="label">
                            Vehículos seleccionados para pre entregar
                        </div>
                        
                        <div class="alert alert-danger" v-if="validation.hasError('form.cars')">Debe seleccionar al menos un vehículo</div>

                        <table class="table mt-2 mb-4" v-if="form.cars.length>0">
                            <tr class="table-head">
                                <td>Chasis</td>
                                <td>Vehículo</td>
                                <td>Cliente</td>
                                <td></td>
                            </tr>
                            <tr v-for="(item, index) of form.cars" :key="item.id" >
                                <td>{{item.chassis_number}}</td>
                                <td>
                                    <div class="tc">
                                        <span class="text-primary">{{item.brand.title}}</span>
                                        <span >{{item.model}}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="tc">
                                        <span class="text-primary">{{item.client.name}}</span>
                                        <span >{{item.client.business_name}}</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="btn btn-xs btn-light" @click="deselectCar(index)"><i class="fa fa-times"></i></div>
                                </td>
                            </tr>
                        </table>

                        <div class="overflow-hidden mt-3">
                            <button type="submit" class="btn btn-primary" @click="save()" >Confirmar solicitud</button>
                        </div>

                    </div>

                </div>
            </div>

		</div>
    </div>

	<Loader :show="saving || loading"></Loader>

	
</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import Navbar from '@/components/Navbar'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;


export default {
	name: 'requestPreDelivery',
	components:{
        Loader,
        Navbar,
    },
    mixins: [mixins],
	data () {
		return {
            searchTerms:null,
            show: false,
			form: {
                cars:[],
                priority:null
            },
            cars: [],
			loading: false,
			saving: false,
		}
    },
    computed: {
        // filteredCars: function () {
		// 	return this.cars.filter((car) => {
		// 		if( this.form.cars.map( el => el.id ).indexOf(car.id) < 0 ){
		// 			return car
		// 		}
		// 	}
		// )}
    },
    beforeMount(){
        // this.searchCars()
    },
	validators: {
        'form.cars': function (value) {
			return Validator.custom( () => {
                if(value.length<=0){
					return true
				}
			})
		},
	},
	methods: {
        selectCar(event){
            this.form.cars.push(event)
        },
        deselectCar(index){
            this.form.cars.splice(index,1)
        },
        searchCars(){
            // this.loading = true
			this.$apollo.query({
				query: gql`query ($status: String, $search: String) {
					carsAll(status: $status, search: $search) {
                        id
                        client{
                            name
                        }
                        model
                        brand{
                            title
                        }
                        motor_number
                        chassis_number
                        status
                        statusText
					}
				}`,
				variables: {
					search: this.searchTerms,
					status: 'CAN_REQUEST_PRE_DELIVERY',
				},
				fetchPolicy: 'no-cache'
			})
			.then((data) => {
                this.loading = false
				this.cars = data.data.carsAll;
			});
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
                
                var cars = []
                this.form.cars.forEach(car=>{cars.push(car.id)})
				let dataInput = {
                    cars 		: cars,
                    priority    : this.form.priority
				}
                this.create(dataInput)
			}
		},
		create (data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $data: RequestPreDeliveryInput! ){
					requestPreDelivery( data: $data) {
						id
					}
				}`,
				variables: {
					data
				}
			})
			.then(() => {
				this.$toast.success('Solicitud realizada correctamente')
                this.$router.push('/cars')
                this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		},
	}
}


</script>


<style lang="scss">

</style>